import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function usePolicy(enterpriseId) {
  const [loading, setLoading] = useState(true);
  const [policy, setPolicy] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.enterprises.policy(enterpriseId))
      .then((response) => {
        setPolicy(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, policy };
}
